import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import "../../styles/common/index.css"; // Common styles (PageLayout, ActionBar, FilterForm)
import "./BlacklistUser.css"; // Page-specific styles (Table, etc.)

const BlacklistUser = () => {
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  // Dummy data - later replace with actual API data
  const blacklistedCustomers = [
    {
      id: 1,
      leadNumber: "21218",
      loanNumber: "DFTLADV00000006734",
      customer: "MANOJ",
      mobile: "9881515283",
      panNumber: "DBVPS9461J",
      email: "SANATAN.MANOJ3@GMAIL.COM",
    },
  ];

  const handleDelete = (id) => {
    // TODO: Implement delete functionality with backend
    if (window.confirm("Are you sure you want to remove this customer from blacklist?")) {
      console.log("Deleting blacklisted customer:", id);
      alert(`Customer ${id} removed from blacklist`);
    }
  };

  return (
    <div className="page-wrapper blacklist-user-page">
      {/* Page Header */}
      <div className="page-header-section">
        <div className="page-title-section">
          <h1 className="blacklist-page-title">All Blacklisted Customers</h1>
        </div>
      </div>

      {/* Table Controls */}
      <div className="table-controls">
        <div className="entries-control">
          <label>Show</label>
          <select
            className="entries-select"
            value={entriesPerPage}
            onChange={(e) => setEntriesPerPage(Number(e.target.value))}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span className="entries-label">entries</span>
        </div>
        <div className="table-search">
          <label>Search:</label>
          <input
            type="text"
            className="table-search-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder=""
          />
        </div>
      </div>

      {/* Data Table Section */}
      <div className="data-table-section">
        <table className="blacklist-data-table">
          <thead>
            <tr>
              <th>Lead Number</th>
              <th>Loan Number</th>
              <th>Customer</th>
              <th>Mobile</th>
              <th>PAN Number</th>
              <th>Email</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {blacklistedCustomers.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty-state-cell">
                  <div className="empty-state">
                    <div className="empty-state-icon">🚫</div>
                    <h3 className="empty-state-title">No Blacklisted Customers</h3>
                    <p className="empty-state-message">
                      There are no blacklisted customers at the moment.
                    </p>
                  </div>
                </td>
              </tr>
            ) : (
              blacklistedCustomers.map((customer) => (
                <tr key={customer.id}>
                  <td className="lead-number-cell">{customer.leadNumber}</td>
                  <td className="loan-number-cell">{customer.loanNumber}</td>
                  <td className="customer-cell">{customer.customer}</td>
                  <td className="mobile-cell">{customer.mobile}</td>
                  <td className="pan-number-cell">{customer.panNumber}</td>
                  <td className="email-cell">{customer.email}</td>
                  <td className="action-cell">
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(customer.id)}
                    >
                      <FaTrash className="delete-icon" />
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="pagination-section">
        <div className="pagination-info">
          Showing {blacklistedCustomers.length > 0 ? 1 : 0} to {blacklistedCustomers.length} of {blacklistedCustomers.length} entries
        </div>
        <div className="pagination-controls">
          <button className="pagination-btn pagination-prev-next" disabled>
            Previous
          </button>
          <button className="pagination-btn pagination-number active">1</button>
          <button className="pagination-btn pagination-number">2</button>
          <button className="pagination-btn pagination-number">3</button>
          <button className="pagination-btn pagination-number">4</button>
          <button className="pagination-btn pagination-number">5</button>
          <button className="pagination-btn pagination-ellipsis" disabled>...</button>
          <button className="pagination-btn pagination-number">11</button>
          <button className="pagination-btn pagination-prev-next">
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlacklistUser;

